import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { TagMultiSelectService } from '../../services/multi-select.service';
import { TagMultiSelectComponent } from './multi-select.component';

@NgModule({
    imports: [MaxBrainSharedModule, MatAutocompleteModule, MatChipsModule, MatInputModule, MatFormFieldModule, MatIconModule, MatSelectModule, MatCheckboxModule, MatTooltipModule],
    declarations: [TagMultiSelectComponent],
    providers: [TagMultiSelectService],
    exports: [TagMultiSelectComponent],
})
export class TagMultiSelectModule {}
